import React from 'react';
import PropTypes from 'prop-types';
import { TooltipIcon } from '@jutro/components';
import { RadioButtonUtil } from 'ml-portals-util-js';
import styles from './MLRadioTypelistComponent.module.scss';

import { RadioButton, FieldComponent } from '@jutro/legacy/components';

class MLRadioButtonTypelistComponent extends FieldComponent {
    static propTypes = {
        ...FieldComponent.propTypes,
        availableValues: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
        value: PropTypes.string,
        helpTextTitleMap: PropTypes.shape({}),
        helpTextMap: PropTypes.shape({}),
        showHelpText: PropTypes.bool
    };

    static defaultProps = {
        showHelpText: true
    }

    state = {
        selectedValue: undefined
    };

    componentDidMount() {
        this.setState({selectedValue: this.getDataTypeAwareSelectedValue()})
    }

    getOptionCode = (option) => {
        return option?.code ?? option.id;
    }

    render() {
        return super.render();
    }

    renderRadioOptions(options, helpTextTitleMap, helpTextMap) {
        const {
            id, disabled, required, controlsSize, showHelpText
        } = this.props;

        const { selectedValue } = this.state;

        const { getTabIndex } = RadioButtonUtil;

        const handleValueChange = (targetValue) => {
            this.setState({ selectedValue: targetValue });
            this.handleAvailableValuesValueChange(targetValue);
        }

        return options.map((option, i) => {
            const optionCode = this.getOptionCode(option);
            const shouldRenderTooltip = showHelpText && (helpTextTitleMap[option.code] || helpTextMap[option.code]);

            const tooltipProps = {
                text: shouldRenderTooltip ? helpTextMap[option.code] : undefined,
                title: shouldRenderTooltip ? helpTextTitleMap[option.code] : undefined
            };
            return (
                <>
                    <RadioButton
                        key={optionCode}
                        option={option}
                        id={id}
                        tabIndex={getTabIndex(i)}
                        value={selectedValue}
                        onValueChange={handleValueChange}
                        disabled={disabled}
                        required={required}
                        size={controlsSize}
                        className={shouldRenderTooltip ? styles.radioWithTooltip : ''}
                        {...this.generateDataPathProperty()}
                    />
                    {shouldRenderTooltip && <TooltipIcon {...tooltipProps} />}
                </>
            );
        });
    }

    renderControl(breakpointProps, theme) {
        const {
            id,
            availableValues,
            controlClassName,
            helpTextTitleMap,
            helpTextMap
        } = this.props;
        const { selectedValue } = this.state;

        const triggerFocus = (el, value) => {
            el.querySelector(`label[for$=${value}]`).focus();
            this.setState({ selectedValue: value});
        };
        const { makeHandleRadioButtonKeyDown } = RadioButtonUtil;
        const handleRadioButtonKeyDown = makeHandleRadioButtonKeyDown(
            triggerFocus, selectedValue
        );
        const options = this.renderRadioOptions(availableValues, helpTextTitleMap, helpTextMap);
        const control = (
            // eslint-disable-next-line jsx-a11y/interactive-supports-focus
            (<div
                id={id}
                className={controlClassName}
                role="radiogroup"
                onKeyDown={(event) => handleRadioButtonKeyDown(
                    event,
                    breakpointProps,
                    this.handleAvailableValuesValueChange
                )}
                {...this.generateAccessibilityProperties(theme)}
            >
                {options}
            </div>)
        );

        return control;
    }
}

export default MLRadioButtonTypelistComponent;
